import axios from "axios";
import helpers from "@/helpers.js";
import store from '../../store'
// import firebase from "firebase";

class Tags {

    constructor() {

    }

    save_settings(data) {

        // let params = "" ;

        // params = params + "&company_id="+store.state.companies.currentCompany.id ;
        // params = params + "&device_id="+data.device_id;
        // params = params + "&type="+data.type;
        // params = params + "&name="+data.name;
        // params = params + "&description="+data.description;
        // params = params + "&unit="+data.unit;
        // params = params + "&alarm_prio="+data.alarm_prio;
        // params = params + "&email_addresses="+data.email_addresses;
        // params = params + "&call_numbers="+data.call_numbers;
        // params = params + "&sms_numbers="+data.sms_numbers;

        if(!data.description){
            data.description = '';
        }
        
        store.commit("app/SET_LOADER", true) ;

        return helpers.get_token().then(function(idToken) {
            
            const config = {
                headers: { Authorization: "Bearer " + idToken }
            };
            
            // console.log('data'); 
            // console.log(data); 

            return axios.put( 
                helpers.get_api_endpoint("/tags/"+ data.id),
                {
                    company_id : store.state.companies.currentCompany.id,
                    device_id : data.device_id,
                    type : data.type,
                    name : data.name,
                    description : data.description,
                    unit : data.unit,
                    alarm_prio : data.alarm_prio,
                    email_addresses : data.email_addresses,
                    call_numbers : data.call_numbers,
                    sms_numbers : data.sms_numbers
                },
                config
            ).then(function(response) {

                store.commit("app/SET_LOADER", false) ;

                return response.data ; 

            })
            .catch(error => {

                console.log('error 1 ');

                store.commit("app/SET_ERROR", error) ;
                return error ; 
            });

        }).catch(function(error) {

            console.log('error 2');

            store.commit("app/SET_ERROR", error) ;
            return error ; 
  
        });
        
    }

    update_value(data) {
        
        return helpers.get_token().then(function(idToken) {
            
            const config = {
                headers: { Authorization: "Bearer " + idToken }
            };
           
            return axios.put( 
                helpers.get_api_endpoint("/tags/"+ data.id +"/setpoint"),
                {
                    company_id: store.state.companies.currentCompany.id,
                    device_id: data.device_id,
                    type: data.type,
                    value: data.value
                },
                config
            ).then(function(response) {

                return response.data ; 

            })
            .catch(error => {
                store.commit("app/SET_ERROR", error) ;
                return error ; 
            });

        }).catch(function(error) {

            store.commit("app/SET_ERROR", error) ;
            return error ; 
  
        });
        
    }

}

export default Tags ;
